import React from 'react';
import { useTranslation } from 'react-i18next';

interface TableHeaderSectionProps {
  total: number;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total }) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center">
          <i className="ri-capsule-line ri-22px"></i>
          <h5 className="mx-3 my-0">
            {t('products.list.pageTexts.table.headerSection.title')} ({total})
          </h5>
        </div>
      </div>
    </div>
  );
};

export default TableHeaderSection;
